module.exports = __webpack_public_path__ + "img/er.9c3ff8cb.svg";